import { useState, useCallback } from 'react';
export const useLoadingWithMinDuration = <T extends any[], R>(
    minDuration: number = 500
) => {
    const [isLoading, setIsLoading] = useState(false);

    const execute = useCallback(async (fn: (...args: T) => Promise<R>, ...args: T): Promise<R | undefined> => {
        setIsLoading(true);
        const startTime = Date.now();

        try {
            const result = await fn(...args);
            return result;
        } finally {
            // Ensure minimum loading duration for better UX
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(0, minDuration - elapsedTime);

            if (remainingTime > 0) {
                await new Promise(resolve => setTimeout(resolve, remainingTime));
            }

            setIsLoading(false);
        }
    }, [minDuration]);

    return { isLoading, execute };
};

